import {
    Controller
} from "stimulus"
import Playr from 'plyr'

export default class extends Controller {

    /**
     * Dont load the carousel until all the assets (like fonts) are loaded.
     * Late font loads can shift element positions and break swiper.
     */
    initialize() {
        new Playr(this.element, {
        })
    }
}


